export default __webpack_public_path__ + "files/media/hd-nysf.d04eb078.jpg";